import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const GET_SUPPLY_CHAIN: TypedDocumentNode<Data, Variables> = gql`
  query getSupplyChain($id: ID!) {
    node(id: $id) {
      ... on SupplyChain {
        id
        asi
        defaultSid
        name
      }
    }
  }
`
